module.exports = __webpack_public_path__ + "./images/88b5ceeaa778bf499b9df5edc40d84be.webp";